import { styled } from '@mui/material';
import Box from '@mui/material/Box';

const PasswordModuleStyledContainer = styled(Box)`
  .card {
    display: flex;
    position: relative;
    gap: 20px;
    flex-direction: column;
  }

  .module-title {
    color: #3460b4;
    font-weight: 500;
    font-size: 16px;
  }
`;

export { PasswordModuleStyledContainer };
